import {
  Action,
  ThunkAction,
  combineReducers,
  configureStore,
  createAction,
} from '@reduxjs/toolkit';

import systemReducer from './system';

export const resetStore = createAction('resetStore');

const appReducer = combineReducers({
  system: systemReducer,
});

const rootReducer = (state: any, action: any) => {
  if (action.type === resetStore.type) {
    // Reset toàn bộ state về undefined để các reducer trả về trạng thái mặc định
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

export const store = configureStore({
  devTools: process.env.NODE_ENV === 'development',
  reducer: rootReducer,
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
